module.exports = __webpack_public_path__ + "img/drop.bb5ddb35.svg";